import React from 'react';
import Banner from './Banner';
import { IconCuenta } from './icons';

export default function BannerCuenta() {
  return (
    <>
      <div className="options-subtitle">¿No tenés cuenta Itaú?</div>
      <Banner
        href="https://www.itau.com.uy/inst/abritucuenta.html"
        text="Abrila desde tu celular"
        icon={<IconCuenta />}
      />
    </>
  );
}
